import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import GdprName from "../common/GdprName";

class CrewList extends React.Component {
  render() {
    let captain = this.props.captain;
    let captainRow = (
      <tr>
        <th>
          <Link to={`/people/${captain.id}`}>
            <GdprName person={captain} prefix={<FormattedMessage id="abbr.captain" defaultMessage="cpt." />} />
          </Link>
        </th>
      </tr>
    );

    let coSkipper = this.props.coSkipper;
    let coSkipperRow = coSkipper ? (
      <tr>
        <th>
          <Link to={`/people/${coSkipper.id}`}>
            <GdprName person={coSkipper} prefix={<FormattedMessage id="abbr.coSkipper" defaultMessage="co-skipper" />} />
          </Link>
        </th>
      </tr>
    ) : null;

    let crewRows = this.props.crew.map((person) => (
      <tr key={person.id}>
        <td>
          <Link to={`/people/${person.id}`}>
            <GdprName person={person} />
          </Link>
        </td>
      </tr>
    ));
    return (
      <table className="ui celled padded table">
        <thead>
          {captainRow}
        </thead>
        <tbody>
          {coSkipperRow}
          {crewRows}
        </tbody>
      </table>
    );
  }
}

export default CrewList;
